// 推薦・総合のデフォルト試験名
export const SPECIAL_ADMISSIONS_DEFAULT_NAME = '小論文';
// 科目名を強制的に変更する試験のリスト
export const EXAM_SUBJECT_DISPLAY_NAMES = {
  '1599990201': '数学IA',
  '1599990202': '数学I',
  '1599990203': '数学IIB',
  '1599990204': '数学II',
  '1699990201': '数学IA',
  '1699990202': '数学I',
  '1699990203': '数学IIB',
  '1699993004': '数学II',
  '1799990201': '数学IA',
  '1799990202': '数学I',
  '1799990203': '数学IIB',
  '1799990204': '数学II',
  '1899990201': '数学IA',
  '1899990202': '数学I',
  '1899990203': '数学IIB',
  '1899990204': '数学II',
  '1999990201': '数学IA',
  '1999990202': '数学I',
  '1999990203': '数学IIB',
  '1999990204': '数学II',
  '2099990201': '数学IA',
  '2099990202': '数学I',
  '2099990203': '数学IIB',
  '2099990204': '数学II',
  '2199990201': '数学IA',
  '2199990203': '数学IIB',
  '2299990201': '数学IA',
  '2299990203': '数学IIB',
  '1599990401': '物理',
  '1599990402': '物理基礎',
  '1699990401': '物理',
  '1699990402': '物理基礎',
  '1799990401': '物理',
  '1799990402': '物理基礎',
  '1899990401': '物理',
  '1899990402': '物理基礎',
  '1999990401': '物理',
  '1999990402': '物理基礎',
  '2099990401': '物理',
  '2099990402': '物理基礎',
  '2199990401': '物理',
  '2199990402': '物理基礎',
  '2299990401': '物理',
  '2299990402': '物理基礎',
  '1599990501': '化学',
  '1599990502': '化学基礎',
  '1699990501': '化学',
  '1699990502': '化学基礎',
  '1799990501': '化学',
  '1799990502': '化学基礎',
  '1899990501': '化学',
  '1899990502': '化学基礎',
  '1999990501': '化学',
  '1999990502': '化学基礎',
  '2099990501': '化学',
  '2099990502': '化学基礎',
  '2199990501': '化学',
  '2199990502': '化学基礎',
  '2299990501': '化学',
  '2299990502': '化学基礎',
  '1899990601': '生物',
  '1899990602': '生物基礎',
  '1999990601': '生物',
  '1999990602': '生物基礎',
  '2099990601': '生物',
  '2099990602': '生物基礎',
  '2199990601': '生物',
  '2199990602': '生物基礎',
  '2299990601': '生物',
  '2299990602': '生物基礎',
  '1799990702': '日本史B',
  '1899990702': '日本史B',
  '1999990702': '日本史B',
  '2099990702': '日本史B',
  '2199990702': '日本史B',
  '2299990702': '日本史B',
  '1599990802': '世界史B',
  '1699990802': '世界史B',
  '1799990802': '世界史B',
  '1899990802': '世界史B',
  '1999990802': '世界史B',
  '2099990802': '世界史B',
  '2199990802': '世界史B',
  '2199990804': '世界史B',
  '2299990802': '世界史B',
  '2399990201': '数学IA',
  '2399990202': '数学I',
  '2399990203': '数学IIB',
  '2399990204': '数学II',
  '2399990401': '物理',
  '2399990402': '物理基礎',
  '2399990501': '化学',
  '2399990502': '化学基礎',
  '2399990701': '日本史A',
  '2399990702': '日本史B',
  '2399990801': '世界史A',
  '2399990802': '世界史B',
  '2399990601': '生物',
  '2399990602': '生物基礎',
  '2099990902': '地理B',
  '2199990902': '地理B',
  '2299990902': '地理B',
  '2399990901': '地理A',
  '2399990902': '地理B',
  '2499990201': '数学IA',
  '2499990202': '数学I',
  '2499990203': '数学IIB',
  '2499990204': '数学II',
  '2499990401': '物理',
  '2499990402': '物理基礎',
  '2499990501': '化学',
  '2499990502': '化学基礎',
  '2499990701': '日本史A',
  '2499990702': '日本史B',
  '2499990801': '世界史A',
  '2499990802': '世界史B',
  '2499990601': '生物',
  '2499990602': '生物基礎',
  '2499990901': '地理A',
  '2499990902': '地理B',
  '2599990201': '数学IA',
  '2599990202': '数学I',
  '2599990203': '数学IIBC',
  '2599990401': '物理',
  '2599990402': '物理基礎',
  '2599990501': '化学',
  '2599990502': '化学基礎',
  '2599990601': '生物',
  '2599990602': '生物基礎',
  '2599990701': '歴史総合，日本史探究',
  '2599990801': '歴史総合，世界史探究',
  '2599990901': '地理総合，地理探究',
  '2599990902': '地理総合',
  '2599991001': '公共，政治・経済',
  '2599990204': '情報I',
  '2501505002': '総合問題',
  '2501905001': '数学',
  '2503105001': '総合問題',
  '2502805001': '数学',
  '2502805002': '生物',
  '2502455002': '総合問題',
  '2504605002': '総合問題',
  '2505105001': '総合問題',
  '2506805001': '総合問題',
  '2507905001': '総合問題',
  '2510155001': '総合問題',
  '2510205001': '総合問題',
  '2510215001': '総合問題',
  '2510255001': '総合問題',
  '2510305001': '総合問題',
  '2510575001': '総合問題',
  '2510785001': '総合問題',
  '2510855001': '総合問題',
  '2510925001': '総合問題',
  '2511105001': '化学',
  '2511505002': '総合問題',
  '2511525001': '総合問題',
  '2511555001': '総合問題',
  '2511805001': '総合問題',
  '2512255001': '総合問題',
  '2512355001': '総合問題',
  '2512755001': '総合問題',
  '2513095001': '総合問題',
  '2513605001': '総合問題',
  '2513625001': '総合問題',
  '2523705001': '総合問題',
  '2536005001': '英語',
  '2542705001': '総合問題',
  '2401905001': '数学',
  '2403105001': '総合問題',
  '2402305001': '総合問題',
  '2402455002': '総合問題',
  '2402805001': '総合問題',
  '2402805002': '生物',
  '2404505001': '総合問題',
  '2404505002': '総合問題',
  '2404605002': '総合問題',
  '2405105001': '総合問題',
  '2406805001': '総合問題',
  '2408405001': '総合問題',
  '2408805001': '総合問題',
  '2410155001': '総合問題',
  '2410205001': '総合問題',
  '2410255001': '英語',
  '2410305001': '総合問題',
  '2410855001': '総合問題',
  '2410925001': '総合問題',
  '2434255001': '数学',
  '2411105001': '総合問題',
  '2411505002': '総合問題',
  '2411525001': '総合問題',
  '2411555001': '総合問題',
  '2411805001': '総合問題',
  '2412255001': '英語',
  '2412755001': '総合問題',
  '2413095001': '総合問題',
  '2413605001': '総合問題',
  '2413625001': '総合問題',
  '2423105001': '総合問題',
  '2423705001': '総合問題',
  '2300105001': '総合問題',
  '2303105001': '総合問題',
  '2302805001': '総合問題',
  '2302805002': '総合問題',
  '2304505002': '総合問題',
  '2304605002': '総合問題',
  '2305105001': '総合問題',
  '2307605002': '総合問題',
  '2307605003': '総合問題',
  '2307905003': '総合問題',
  '2308805001': '総合問題',
  '2310155001': '総合問題',
  '2310205001': '総合問題',
  '2310215001': '総合問題',
  '2310255001': '英語',
  '2310305001': '総合問題',
  '2310305002': '総合問題',
  '2310855001': '総合問題',
  '2310855002': '数学',
  '2310925001': '総合問題',
  '2334255001': '数学',
  '2311055001': '総合問題',
  '2311105001': '化学',
  '2311505002': '総合問題',
  '2311525001': '英語',
  '2311805001': '総合問題',
  '2312255001': '総合問題',
  '2312755001': '総合問題',
  '2312755002': '総合問題',
  '2313095001': '総合問題',
  '2313095002': '数学',
  '2313605001': '総合問題',
  '2313625001': '総合問題',
  '2323705001': '総合問題',
  '2340605001': '国語',
  '2342705001': '国語',
  '2422605011': '英語',
  '2423205012': '総合問題',
  '2523205012': '総合問題',
  '2423505011': '総合問題',
  '2523505011': '総合問題',
  '2424305011': '総合問題',
  '2524305011': '総合問題',
  '2428705011': '英語',
  '2428705012': '化学',
  '2528705011': '化学',
  '2431305011': '英語',
  '2436605011': '総合問題',
  '2536605011': '総合問題',
  '2439205011': '総合問題',
  '2440305011': '総合問題',
  '2540305011': '総合問題',
  '2440605011': '英語',
  '2440605012': '国語',
  '2540605011': '英語',
  '2540605012': '国語',
  '2442505011': '総合問題',
  '2542505011': '総合問題',
  '2444105011': '国語',
  '2544105011': '英語',
  '2544105012': '国語'
};
